<template>
  <v-container
    fluid
    class="fill-height"
    style="position: relative"
    ref="ScadaPage"
  >
    <div
      v-if="editingPage"
      class="image"
    >
      <img
        class="background"
        draggable="false"
        v-if="editingPage.background_image != null && typeof editingPage.background_image == 'string'"
        :src="editingPage.background_image"
        @error="errorHandler"
      />
    </div>
    <template v-for="(item, index) in editingPage.item_list">
      <MoveableComponentVue

        v-if="mostrar(item)"
        :index="index"
        :input="editingPage"
        :item="item"
        :key="index"
      >
        <component
          :is="item.settings.component_type"
          :input="item"
        >
        </component>
      </MoveableComponentVue>
    </template>
    <v-footer
      v-show="show_bottom_window"
      app
      color="gray"
      height="200"
      inset
      ref="GlobalItemsWindow"
      class="pa-1"
    >
      <MoveableComponentVue
        v-for="(item, index) in editingPage.global_item_list"
        :index="index"
        :input="editingPage"
        :item="item"
        :key="index"
      >
        <component
          :is="item.settings.component_type"
          :input="item"
        >
        </component>
      </MoveableComponentVue>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MoveableComponentVue from "../generic/MoveableComponent.vue";
export default {
  components: {
    MoveableComponentVue,
  },

  data() {
    return {};
  },

  computed: {
    ...mapState(["editing", "selectedPage"]),

   

    editingPage() {
      return this.actualPage();
    },

    show_bottom_window() {
      return this.editing && this.editingPage.global_item_list.length > 0;
    },
  },

  methods: {
    ...mapGetters(["actualPage", "userRole"]),
    ...mapActions(["setSelectedPageToHome", "setSelectedPageToBack"]),

    errorHandler() {
      console.log("error al cargar la imagen");
    },
    mostrar(item){
      //si tiene propiedad active y lo tiene a false, no hay que pintar. De otro cualquier modo sí
      return (!item?.settings?.authorized_roles?.length > 0 || item?.settings?.authorized_roles?.includes(this.userRole())) && item?.customized?.active !== false
    },
  },

  created() {
    this.selectedPage == 0 ? this.setSelectedPageToHome() : this.setSelectedPageToBack();
  },
};
</script>

<style>
.background {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
  left: 0px;
}

.image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}
</style>
